<template>
  <div>
    <button
      :class="{
        'text-primary-800': !isOpen,
        'text-primary-500': isOpen,
      }"
      class="ease-out-expo flex w-full items-center justify-between gap-4 py-3 text-left text-[1.125rem] font-medium transition-colors duration-700 lg:pb-4"
      @click="toggle"
    >
      {{ blok.title }}

      <div
        :class="{
          'rotate-0 text-gray-500': !isOpen,
          'text-primary-500 rotate-180': isOpen,
        }"
        class="ease-out-expo flex-none transform transition-all duration-700"
      >
        <UiIcon icon="chevron-down" size="md" />
      </div>
    </button>

    <div v-if="isOpen">
      <div class="pb-9">
        <BlockRichText
          v-for="richText in blok.content"
          :key="richText._uid"
          :blok="richText"
          class="text-secondary"
          :page-section-theme="pageSectionTheme"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  BlockAccordionItemStoryblok,
  PageSectionStoryblok,
} from '@/types/storyblok'

defineProps<{
  blok: BlockAccordionItemStoryblok
  pageSectionTheme: PageSectionStoryblok['theme']
}>()
const isOpen = ref<boolean>(false)

function toggle(): void {
  isOpen.value = !isOpen.value
}
</script>
